import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { keepPreviousData } from '@tanstack/react-query';
import { AssumptionSetWithStoredName } from '@/services/models/assumptionSet/assumptionSets';
import { showError } from '@/utils/toast';
import { trpc } from '@/utils/trpc';
import useLastModifications from '../useLastModification';
type UseAssumptionSetsProps = {
  networkId: string;
};
export const useAssumptionSets = t0 => {
  const $ = _c(12);
  const {
    networkId
  } = t0;
  const {
    data: lastModifications
  } = useLastModifications(networkId);
  let t1;
  if ($[0] !== networkId) {
    t1 = {
      networkId
    };
    $[0] = networkId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = !!lastModifications?.assumptionSet;
  let t3;
  if ($[2] !== t2) {
    t3 = {
      enabled: t2,
      placeholderData: keepPreviousData
    };
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const {
    data: assumptionSets,
    isLoading,
    isError,
    isFetched,
    refetch
  } = trpc.assumptionSet.getAssumptionSets.useQuery(t1, t3);
  let t4;
  let t5;
  if ($[4] !== isError) {
    t4 = () => {
      if (isError) {
        showError("Failed to load assumptionSets.", {
          description: "Check your internet connection and try again."
        });
      }
    };
    t5 = [isError];
    $[4] = isError;
    $[5] = t4;
    $[6] = t5;
  } else {
    t4 = $[5];
    t5 = $[6];
  }
  useEffect(t4, t5);
  let t6;
  if ($[7] !== assumptionSets || $[8] !== isFetched || $[9] !== isLoading || $[10] !== refetch) {
    t6 = {
      data: assumptionSets,
      isLoading,
      isFetched,
      refetch
    };
    $[7] = assumptionSets;
    $[8] = isFetched;
    $[9] = isLoading;
    $[10] = refetch;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};
export default useAssumptionSets;